import { Info } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../ui/popover";

// Definizione testi informativi per ogni pagina/tab admin
// Formato: "In [Nome] puoi..." per chiarezza
const pageInfoTexts = {
  // Dashboard (senza sottovoci)
  dashboard: "In Dashboard trovi la panoramica generale dell'attività: prossimi soggiorni, calendario mensile, statistiche di occupazione e revenue, stato sincronizzazione con le piattaforme e accesso rapido alle funzioni principali.",
  
  // Update (senza sottovoci)
  update: "In Update visualizzi tutte le nuove prenotazioni rilevate dal sito (Form, Payment Link) e dalle piattaforme esterne (Airbnb, Booking, ecc.) ordinate per data di rilevamento. Qui puoi monitorare l'attività di prenotazione in tempo reale e gestire i record.",
  
  // Booking - 4 sottovoci (escluso Cleaning che è un link)
  booking_booking: "In Booking gestisci il calendario interattivo delle prenotazioni. Puoi visualizzare check-in/check-out, bloccare date manualmente, vedere le prenotazioni da tutte le fonti e gestire i prezzi per periodo tramite la griglia tariffaria.",
  booking_source: "In Data Source configuri le piattaforme esterne (Airbnb, Booking.com, Vrbo, ecc.) da cui importare le prenotazioni via iCal. Puoi aggiungere, modificare o eliminare sorgenti e impostare l'URL pubblico per l'export del calendario verso le piattaforme.",
  booking_sync: "In Sync monitori lo storico delle sincronizzazioni iCal e le prenotazioni importate. Usa il toggle per passare tra 'Log tecnici' (tutti i controlli del sistema) e 'Prenotazioni' (solo quando vengono rilevate nuove prenotazioni). Include statistiche per periodo, dettagli di ogni sync e filtri per piattaforma.",
  booking_settings: "In Settings configuri le impostazioni generali del booking: numero massimo ospiti, soggiorno minimo, finestra di prenotazione, tariffe extra ospite, pulizie, tassa di soggiorno e altre opzioni operative.",
  
  // Sync - widget specifici
  nuove_prenotazioni_rilevate: "Mostra le ultime prenotazioni rilevate durante le sincronizzazioni iCal (Airbnb, Booking.com, etc.). Ogni riga rappresenta un evento di sync con prenotazioni importate. Puoi selezionare ed eliminare singole o multiple prenotazioni. Le prenotazioni vengono eliminate automaticamente dopo 90 giorni.",
  ultime_prenotazioni_rilevate: "Mostra le ultime prenotazioni rilevate durante le sincronizzazioni iCal (Airbnb, Booking.com, etc.). Ogni riga rappresenta un evento di sync con prenotazioni importate. Puoi selezionare ed eliminare singole o multiple prenotazioni. Le prenotazioni vengono eliminate automaticamente dopo 90 giorni.",
  log_tecnici: "Mostra gli errori di sincronizzazione del sistema iCal. Solo gli errori che richiedono attenzione vengono visualizzati qui. I sync completati senza problemi non vengono mostrati. I log vengono eliminati automaticamente dopo 90 giorni.",
  log_ical: "Mostra gli errori di sincronizzazione del sistema iCal. Solo gli errori che richiedono attenzione vengono visualizzati qui. I sync completati senza problemi non vengono mostrati. I log vengono eliminati automaticamente dopo 90 giorni.",
  cronologia_sync: "Mostra i log di sincronizzazione e lo stato tecnico del sistema (iCal, importazioni, aggiornamenti), inclusi eventuali errori o warning. I log vengono conservati per 90 giorni.",
  log_tecnici: "Mostra gli errori di sincronizzazione del sistema iCal. Solo gli errori che richiedono attenzione vengono visualizzati qui. I sync completati senza problemi non vengono mostrati. I log vengono eliminati automaticamente dopo 90 giorni.",
  
  // Monitoring - 4 sottovoci
  monitoring_transactions: "In Transactions consulti l'elenco e lo stato delle transazioni di pagamento relative alle prenotazioni effettuate tramite Book Now del Form oppure tramite Payment Link. Qui puoi verificare importi, stato del pagamento, data, ID transazione ed esportare i dati.",
  monitoring_tracking: "In Tracking monitori lo stato di ogni prenotazione nel suo ciclo di vita: dalla richiesta alla conferma, dal pagamento al check-out. Include filtri per stato, fonte e anno per una visione d'insieme di tutte le prenotazioni.",
  monitoring_logs: "In Logs visualizzi i log tecnici del sistema: invii email, sincronizzazioni iCal, errori e operazioni di sistema. Utile per debug, verificare che le email partano correttamente e monitorare eventuali problemi.",
  monitoring_overbooking: "In Overbooking monitori i conflitti tra le prenotazioni del sito e le piattaforme esterne. Il sistema rileva automaticamente sovrapposizioni di date e ti permette di gestirle segnandole come risolte o in gestione.",
  
  // Proposal (senza sottovoci)
  proposal: "In Proposal crei preventivi personalizzati da inviare ai potenziali ospiti. Inserisci date, numero ospiti e il sistema calcola automaticamente il totale. Puoi personalizzare il template PDF e scaricarlo per l'invio.",
  
  // Payment Link - 3 sottovoci (nomi corrispondono alle tab visibili)
  payment_link_create: "In Crea Payment Link generi un link di pagamento personalizzato da inviare al cliente. Inserisci i dettagli della prenotazione (date, ospiti, importo) e puoi inviarlo direttamente via email o copiare il link.",
  payment_link_list: "In Elenco Link visualizzi tutti i payment link creati con il loro stato (pagato, in attesa, scaduto). Puoi copiare i link, rinviarli via email o eliminarli.",
  payment_link_platform: "In Platform configuri le impostazioni del provider di pagamento (Stripe): modalità test/live, valuta, email di notifica e verifica lo stato della configurazione.",
  
  // Report - sottovoci (nomi corrispondono alle tab visibili)
  report_tassa_soggiorno: "In Tassa di Soggiorno generi il report dettagliato per il Comune: importi dovuti, numero ospiti tassabili, esenzioni per età. Puoi filtrare per mese ed esportare in Excel per la comunicazione agli enti.",
  report_importi: "In Importi analizzi gli importi incassati per ogni soggiorno: totale soggiorno, pulizie, tassa, base imponibile, cedolare secca e netto. Esportabile in Excel per la contabilità.",
  report_occupazione: "In Occupazione visualizzi le statistiche di occupazione della struttura: percentuale mensile, giorni occupati vs disponibili, confronto con periodi precedenti.",
  report_guadagni: "In Guadagni analizzi il guadagno netto mensile: totale per mese, media per prenotazione, suddivisione per fonte (sito, Airbnb, Booking). Esportabile per la contabilità.",
  
  // Email Form - sottovoci
  email_form_customer_payment: "In E-mail Customer Payment configuri il template dell'email automatica inviata al cliente dopo il pagamento. Personalizza oggetto, corpo del messaggio e variabili dinamiche.",
  email_form_admin_payment: "In E-mail Admin Payment configuri l'email di notifica che ricevi tu come admin quando un cliente completa un pagamento.",
  email_form_customer_message: "In E-mail Customer Message configuri la risposta automatica inviata a chi compila il form di contatto del sito.",
  email_form_admin_message: "In E-mail Admin Message configuri l'email di notifica che ricevi quando qualcuno invia un messaggio dal form di contatto.",
  email_form_settings: "In Settings configuri le impostazioni generali delle email: indirizzo mittente, email di notifica admin, e opzioni di hold per le prenotazioni.",
  
  // Messages (senza sottovoci)
  messages: "In Messages gestisci i testi multilingua del sito: titoli, descrizioni, pulsanti e messaggi. Puoi modificare i contenuti in ogni lingua supportata e utilizzare la traduzione automatica AI.",
  
  // Sections (senza sottovoci)
  sections: "In Sections gestisci le sezioni della homepage del sito: aggiungi, modifica, riordina e personalizza i contenuti (testi, immagini, gallery) visibili ai visitatori.",
  
  // Typography (senza sottovoci)
  typography: "In Typography personalizzi l'aspetto tipografico del sito: font per titoli e testo, dimensioni, colori e stile dei pulsanti del form di prenotazione.",
  
  // Legal (senza sottovoci)
  legal: "In Legal gestisci i contenuti del footer del sito: informazioni legali, voci della sezione Policy (Privacy, Termini, Cookie) e della sezione Contact con link personalizzabili.",
  
  // Account (senza sottovoci)
  account: "In Account gestisci gli utenti del pannello admin: aggiungi o rimuovi amministratori, gestisci gli utenti pulizie con accesso limitato e modifica le credenziali di accesso.",

  // Dashboard widgets
  ultime_attivita: "Ultime Attività mostra le 10 azioni più recenti nel sistema: prenotazioni confermate, messaggi ricevuti, pagamenti completati, email inviate, nuovi visitatori, prenotazioni iCal e overbooking rilevati. Per ogni evento viene indicata la sezione admin dove trovare i dettagli.",
  errori_sistema: "Errori di Sistema mostra gli ultimi 10 errori rilevati nel sistema: email non inviate, pagamenti falliti, errori sync iCal, payment link non pagati e overbooking aperti. Per ogni errore viene indicata la sezione admin dove intervenire. Se non ci sono errori, non verrà mostrato nulla.",
  stato_sync: "Stato Sincronizzazione mostra lo stato delle piattaforme iCal configurate (Airbnb, Booking, Vrbo, ecc.). Per ogni piattaforma puoi vedere: ultima sincronizzazione, numero prenotazioni importate ed eventuali errori. L'esito generale è OK se tutte le piattaforme sono sincronizzate correttamente.",
  prenot_totali_sync: "Prenot. Totali Sync è la sommatoria di tutte le prenotazioni importate da TUTTE le piattaforme iCal configurate (Airbnb, Booking, Vrbo, ecc.). Include prenotazioni fino alla data più lontana presente nel calendario di ogni piattaforma.",
  nuove_prenot_7gg: "Nuove Prenot. 7 GG indica il numero di nuove prenotazioni rilevate dalle piattaforme iCal negli ultimi 7 giorni. Include solo le prenotazioni importate di recente, non quelle già presenti.",
  update_preview: "Update mostra le ultime 10 prenotazioni rilevate dal sistema (sito, piattaforme esterne). Le righe evidenziate in oro con badge numerico sono eventi non ancora verificati/visti. Cliccando 'Vai a Update' accedi alla lista completa.",
};

// Componente solo icona (per widget dashboard)
export function PageInfoIcon({ pageKey, className = "" }) {
  const infoText = pageInfoTexts[pageKey];
  
  if (!infoText) return null;
  
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button 
          className={`inline-flex items-center justify-center text-[#A8A29E] hover:text-[#78716C] transition-colors ${className}`}
          aria-label="Informazioni"
        >
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5"/>
            <path d="M8 7V11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            <circle cx="8" cy="5" r="0.75" fill="currentColor"/>
          </svg>
        </button>
      </PopoverTrigger>
      <PopoverContent 
        className="w-[calc(100vw-2rem)] sm:w-80 max-w-sm p-4 text-sm text-[#44403C] bg-white border border-[#E7E5E4] shadow-lg"
        align="end"
        side="bottom"
        sideOffset={5}
        collisionPadding={16}
      >
        <p className="leading-relaxed">{infoText}</p>
      </PopoverContent>
    </Popover>
  );
}

// Componente per pagine SENZA sottovoci (posizionato a destra del titolo)
export function PageInfoInline({ pageKey, className = "" }) {
  const infoText = pageInfoTexts[pageKey];
  
  if (!infoText) return null;
  
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button 
          className={`inline-flex items-center gap-1 text-[#A8A29E] hover:text-[#78716C] transition-colors text-sm ml-auto ${className}`}
          aria-label="Informazioni sulla pagina"
        >
          <Info size={14} />
          <span className="hidden sm:inline">Info</span>
        </button>
      </PopoverTrigger>
      <PopoverContent 
        className="w-[calc(100vw-2rem)] sm:w-80 max-w-sm p-4 text-sm text-[#44403C] bg-white border border-[#E7E5E4] shadow-lg"
        align="end"
        side="bottom"
        sideOffset={5}
        collisionPadding={16}
      >
        <p className="leading-relaxed">{infoText}</p>
      </PopoverContent>
    </Popover>
  );
}

// Componente per pagine CON sottovoci (posizionato sotto i tabs, allineato a destra)
export function PageInfoUnderTabs({ pageKey, className = "" }) {
  const infoText = pageInfoTexts[pageKey];
  
  if (!infoText) return null;
  
  return (
    <div className={`flex justify-end mt-3 mb-4 ${className}`}>
      <Popover>
        <PopoverTrigger asChild>
          <button 
            className="inline-flex items-center gap-1 text-[#A8A29E] hover:text-[#78716C] transition-colors text-sm"
            aria-label="Informazioni sulla pagina"
          >
            <Info size={14} />
            <span className="hidden sm:inline">Info</span>
          </button>
        </PopoverTrigger>
        <PopoverContent 
          className="w-[calc(100vw-2rem)] sm:w-80 max-w-sm p-4 text-sm text-[#44403C] bg-white border border-[#E7E5E4] shadow-lg"
          align="end"
          side="bottom"
          sideOffset={5}
          collisionPadding={16}
        >
          <p className="leading-relaxed">{infoText}</p>
        </PopoverContent>
      </Popover>
    </div>
  );
}

// Export default per retrocompatibilità (usa PageInfoInline)
export default function PageInfo({ pageKey, className = "" }) {
  return <PageInfoInline pageKey={pageKey} className={className} />;
}

// Export anche i testi per uso diretto se necessario
export { pageInfoTexts };
